export function formatDateRange(
  startIso: string,
  endIso: string,
  timezone: string,
): string {
  const start = new Date(startIso);
  const end = new Date(endIso);

  const opts = (
    parts: Intl.DateTimeFormatOptions,
  ): Intl.DateTimeFormatOptions => ({
    ...parts,
    timeZone: timezone,
  });

  const part = (date: Date, partOpts: Intl.DateTimeFormatOptions): string =>
    new Intl.DateTimeFormat('en-US', opts(partOpts)).format(date);

  const startYear = +part(start, { year: 'numeric' });
  const endYear = +part(end, { year: 'numeric' });
  const startMonth = part(start, { month: 'short' });
  const endMonth = part(end, { month: 'short' });
  const startDay = +part(start, { day: 'numeric' });
  const endDay = +part(end, { day: 'numeric' });
  const year = part(end, { year: 'numeric' });

  // Single day
  if (startMonth === endMonth && startDay === endDay && startYear === endYear) {
    return `${startMonth} ${startDay}, ${year}`;
  }

  // Cross-year
  if (startYear !== endYear) {
    return `${startMonth} ${startDay}, ${startYear} \u2013 ${endMonth} ${endDay}, ${year}`;
  }

  // Same month
  if (startMonth === endMonth) {
    return `${startMonth} ${startDay}\u2013${endDay}, ${year}`;
  }

  // Cross-month, same year
  return `${startMonth} ${startDay} \u2013 ${endMonth} ${endDay}, ${year}`;
}
